export enum popoverTypes {
    td = "td",
    withIcon = "withIcon",
    undefined = "undefined"
}